/**
 * AutryParagraphImages
 */

import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'

// straight import doesn't work; use relative path to module
import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.js'
import PhotoSwipe from '../../node_modules/photoswipe/dist/photoswipe.esm.js'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import '../../node_modules/photoswipe/dist/photoswipe.css'
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css'

Drupal.behaviors.AutryParagraphImages = {
  attach: function (context, settings) {
    const elements = once(
      'AutryParagraphImages',
      '.paragraph-type--images',
      context
    )
    elements.forEach(paragraph => {
      const images = paragraph.querySelector('.paragraph-content')

      // init photoswipe
      const lightbox = new PhotoSwipeLightbox({
        gallery: images,
        children: 'a.photoswipe',
        pswpModule: PhotoSwipe,
        bgOpacity: 0.9,
        padding: { top: 60, bottom: 60, left: 60, right: 60 }
      })
      const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
        type: 'auto',
        verticallyCenterImage: true,
        mobileLayoutBreakpoint: 819,
        captionContent: slide => {
          const figcaption = slide.data.element.nextElementSibling
          return figcaption ? figcaption.innerHTML : null
        }
      })
      lightbox.init()

      // if carousel, init flickity
      if (paragraph.classList.contains('view-mode--carousel')) {
        const carousel = new Flickity(images, {
          arrowShape:
            'M29.7811 59.0905L70.3094 99.6188L78.415 91.5131L37.8868 50.9849L79.0905 9.78113L70.3094 1.00001L29.1057 42.2037L21 50.3094L29.7811 59.0905Z',
          cellAlign: 'left',
          cellSelector: 'figure',
          contain: true,
          freeScroll: false,
          imagesLoaded: true,
          lazyLoad: false,
          pageDots: false,
          percentPosition: false,
          setGallerySize: true
        })
      }
    })
  }
}
